import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

import * as S from './CreateTriggerDrawerLoaded.styles';

export const ErrorText = ({children}: {children: React.ReactNode}) => {
  return <div className="mt-1 text-sm leading-5 text-red-600">{children}</div>;
};

export const BoldLabel = ({children}: {children: React.ReactNode}) => {
  return <div className="font-semibold">{children}</div>;
};

export const SeparatedChunk = ({children}: {children: React.ReactNode}) => {
  return <div className="mt-16">{children}</div>;
};

export const SmallText = ({children}: {children: React.ReactNode}) => {
  return (
    <span className="text-sm text-moon-500 dark:text-wb-text-tertiary">
      {children}
    </span>
  );
};

export const AutomationSummarySection = ({
  eventTitle,
  eventBody,
  actionTitle,
  actionBody,
}: {
  eventTitle: string;
  eventBody: string;
  actionTitle: string;
  actionBody: string;
}) => (
  <S.AutomationDescription>
    <S.AutomationDescriptionBorder />
    <S.AutomationDescriptionInner>
      <S.AutomationDescriptionSection>
        <S.AutomationDescriptionIcon>
          <Icon name="recent-clock" />
        </S.AutomationDescriptionIcon>
        <S.AutomationDescriptionBody>
          <S.AutomationDescriptionTitle>
            {eventTitle}
          </S.AutomationDescriptionTitle>
          <S.AutomationDescriptionText>{eventBody}</S.AutomationDescriptionText>
        </S.AutomationDescriptionBody>
      </S.AutomationDescriptionSection>
      <S.AutomationDescriptionSection>
        <S.AutomationDescriptionIcon>
          <Icon name={'flash-bolt'} />
        </S.AutomationDescriptionIcon>
        <S.AutomationDescriptionBody>
          <S.AutomationDescriptionTitle>
            {actionTitle}
          </S.AutomationDescriptionTitle>
          <S.AutomationDescriptionText>
            {actionBody}
          </S.AutomationDescriptionText>
        </S.AutomationDescriptionBody>
      </S.AutomationDescriptionSection>
    </S.AutomationDescriptionInner>
  </S.AutomationDescription>
);
